export const GET_EVENT_BUSINESS_AREA_API_KEYS_REQUEST = "GET_EVENT_BUSINESS_AREA_API_KEYS_REQUEST";
export const GET_EVENT_BUSINESS_AREA_API_KEYS_SUCCESS = "GET_EVENT_BUSINESS_AREA_API_KEYS_SUCCESS";
export const GET_EVENT_BUSINESS_AREA_API_KEYS_FAILURE = "GET_EVENT_BUSINESS_AREA_API_KEYS_FAILURE";

export const getEventBusinessAreaApiKeysRequest = (eventId, itemOperation, pageKey) => ({
    type: GET_EVENT_BUSINESS_AREA_API_KEYS_REQUEST,
    params: {
        eventId,
        itemOperation,
        pageKey
    }
})

export const getEventBusinessAreaApiKeysSuccess = (apiKeysResult) => ({
    type: GET_EVENT_BUSINESS_AREA_API_KEYS_SUCCESS,
    payload: {
        apiKeysResult
    }
})

export const getEventBusinessAreaApiKeysFailure = (error) => ({
    type: GET_EVENT_BUSINESS_AREA_API_KEYS_FAILURE,
    payload: {
        error
    }
})
